import AxiosService from '../AxiosService';
import { queryString, apiUrl } from '../config/globals';

export const getCategory = (params) => AxiosService.get(`${apiUrl('category', 'private')}/view?${queryString(params)}`);

export const categoryUpdate = (data) => AxiosService.put(`${apiUrl('category', 'private')}/update`, data);

export const getCategories = (data, params, type = 'public') => AxiosService.post(`${apiUrl('category', type)}/search?${queryString(params)}`, data);

export const arrangeCategories = (data) => AxiosService.post(`${apiUrl('category', 'private')}/re-arrange`, data);

export const addCategorySubmit = (data) => AxiosService.post(`${apiUrl('category', 'private')}/save`, data);

export const deleteCategory = (params) => AxiosService.delete(`${apiUrl('category', 'private')}/delete?${queryString(params)}`);

export const activateCategory = (params) => AxiosService.put(`${apiUrl('category', 'private')}/activation?${queryString(params)}`);

export const serviceProviderForm = (data) => AxiosService.post(`${apiUrl('service-provider')}/submit-application`, data);

export const serviceProviderFormEditSubmit = (data) => AxiosService.put(`${apiUrl('service-provider', 'private')}/update`, data);

export const serviceProviderList = (data, params) => AxiosService.post(`${apiUrl('service-provider', 'private')}/search?${queryString(params)}`, data);

export const editServiceProvider = (params) => AxiosService.get(`${apiUrl('service-provider', 'private')}/edit?${queryString(params)}`);

export const serviceProviderAddRedemption = (data) => AxiosService.post(`${apiUrl('service-provider', 'private')}/add-redemption`, data);

export const serviceProviderSingleView = (params) => AxiosService.get(`${apiUrl('service-provider', 'private')}/view?${queryString(params)}`);

export const sendPartnerDetails = (params) => AxiosService.get(`${apiUrl('service-provider', 'private')}/send-details?${queryString(params)}`);
